import { createSlice } from "@reduxjs/toolkit";
import { addQuestion, deleteQuestion,  getAnswerByQuestion, getFaqsAllData, updateStatus } from "./faqsThunk";

const chatbotSlice = createSlice({
    name: 'chatbot',
    initialState: {
      questions: null,
      loading: false,
      getFaqloading: false,
      error: null,
      messsge:null,
      updatemesssge:null,
     deletemesssge:null
    },
    reducers: {},
    extraReducers: (builder) => {
      builder
        .addCase(addQuestion.pending, (state) => {
          state.loading = true;
        })
        .addCase(addQuestion.fulfilled, (state, action) => {
          state.loading = false;
          state.message =action.payload;
        })
        .addCase(addQuestion.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        })
        .addCase(getFaqsAllData.pending, (state) => {
          state.loading = true;
        })
        .addCase(getFaqsAllData.fulfilled, (state, action) => {
          state.getFaqloading = false;
          state.questions = action.payload;
        })
        .addCase(getFaqsAllData.rejected, (state, action) => {
          state.getFaqloading = false;
          state.error = action.payload;
        })
        .addCase(getAnswerByQuestion.pending, (state) => {
          state.getFaqloading = true;
        })
        .addCase(getAnswerByQuestion.fulfilled, (state, action) => {
          state.loading = false;
          // Handle storing the answer if needed
        })
        .addCase(getAnswerByQuestion.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        })
        .addCase(deleteQuestion.pending, (state) => {
          state.loading = true;
        })
        .addCase(deleteQuestion.fulfilled, (state, action) => {
          state.loading = false;
          state.deletemesssge = action.payload


        })
        .addCase(deleteQuestion.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        })
        .addCase(updateStatus.pending, (state) => {
          state.loading = true;
        })
        .addCase(updateStatus.fulfilled, (state, action) => {
          state.loading = false;
          state.updatemesssge = action.payload
          // Update the status of the specific question if needed
        })
        .addCase(updateStatus.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        });
    },
  });
  
  // Export actions if needed
  export const {} = chatbotSlice.actions;
  
  // Export the reducer
  export default chatbotSlice.reducer;